module.exports = __webpack_public_path__ + "static/img/wpp4_1.35bf7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/wpp4_1.png
// module id = pqCv
// module chunks = 2